export enum Experiment {
  UseLocalizationService = 'specs.myAccount.UseLocalizationService',
  EnableGeneralSettings = 'specs.membersArea.generalSettings',
}
